import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Swal from "sweetalert2";
import Login from "./Components/Login/Login";
import Sidemenubar from "./Components/Common/Sidemenubar";
import Header from "./Components/Common/Header";
import Footer from "./Components/Common/Footer";
import AllStaff from "./Components/Staffs/Allstaff";
import StaffAdd from "./Components/Staffs/StaffAdd";
import TestStaffAdd from "./Components/TestFiles/TestStaffAdd";
import StaffProfile from "./Components/Staffs/StaffProfile";
import AddQuestion from "./Components/Questions/AddQuestion";
import AllQuestions from "./Components/Questions/AllQuestions";
import Quiz from "./Components/Exams/Quiz";
import QuizTest from "./Components/Exams/QuizTest";
import OverviewOfCourse from "./Components/CPD/OverviewOfCourse";
import QuizSummary from "./Components/Exams/QuizSummary";
import Dashboard from "./Components/Dashboard/Dashboard";
import QuizList from "./Components/Exams/QuizList";
import Apiservice from "./Components/Apiservice";
import QuestionEdit from "./Components/Questions/QuestionEdit";
import QuizTestReview from "./Components/Exams/QuizTestReview";
import LMSReport from "./Components/Report/LMSReport";
import AttendanceReport from "./Components/Report/AttendanceReport";
import StaffEdit from "./Components/Staffs/StaffEdit";
import Sidemenubar1 from "./Components/Common/Sidemenubar1";
import Home from "./Components/Dashboard/Home";
import Attendance from "./Components/Attendance/Attendance";
import AllSites from "./Components/Site/AllSites";
import AddSite from "./Components/Site/AddSite";
import SiteProfile from "./Components/Site/SiteProfile";
import StaffAttendance from "./Components/Attendance/StaffAttendance";
import StaffAttendanceEdit from "./Components/Attendance/StaffAttendanceEdit";
import TimeSheet from "./Components/Report/TimeSheet";
import SiteEdit from "./Components/Site/SiteEdit";
import KETAdd from "./Components/Staffs/KETAdd";
import KETEdit from "./Components/KET/KETEdit";
import ConsolidateReport from "./Components/Report/ConsolidateReport";
import QuizEdit from "./Components/Exams/QuizEdit";
import LeaveForm from "./Components/Leave/LeaveForm";
import PWMProgression from "./Components/Staffs/PWMProgression";
import LeaveApplicationList from "./Components/Leave/LeaveApplicationList";
import Payslip from "./Components/Payslip/Payslip";
import SalariedStaffs from "./Components/Payslip/SalariedStaffs";
import SOP from "./Components/SOP/SOP";
import SOPAdd from "./Components/SOP/SOPAdd";
import IncidentReport from "./Components/IncidentReport/IR";
import IncidentReportAdd from "./Components/IncidentReport/IRAdd";
import IncidentReportView from "./Components/IncidentReport/IRView";
import EOccurrence from "./Components/Occurrence/EOccurrence";
import EOccurrenceAdd from "./Components/Occurrence/EOccurrenceAdd";
import EoccurrenceReport from "./Components/Report/EoccurrenceReport";
import { getCurrentDate } from '../src/Components/Utils/Utils'
import PaylipList from "./Components/Payslip/PaySlipList";
import FloaterStaffDetails from "./Components/Staffs/FloaterStaffDetails";
import FloaterAttendance from "./Components/Attendance/FloaterAttendance";
import FloaterPage from "./Components/Attendance/FloaterPage";
import QuizAdd from "./Components/Exams/QuizAdd";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState(null);
  const [showSideBar, setShowSideBar] = useState(true);
  const [currentDate, setCurrentDate] = useState('') //yyyy-mm-dd

  const [userType, setUserType] = useState(null);

  useEffect(() => {
    console.log("App.js auth init");

    const token = localStorage.getItem("access_token");
    const storedUserType = localStorage.getItem("userType");

    setUserType(storedUserType);
    setCurrentDate(getCurrentDate());

    if (token && storedUserType === "normal") {
      setIsAuthenticated(true);
      setRole(localStorage.getItem("role_id"));
    }
    else if (storedUserType === "floater") {
      setIsAuthenticated(true);
      setRole(localStorage.getItem("role_id"));
    } else {
      setIsAuthenticated(false);
      setRole(null);
    }

  }, []);


  useEffect(() => {
    // Handle responsive sidebar
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLogin = async (data) => {
    try {
      const result = await Apiservice.Login(data);
      console.log("handle login called")
      console.log("handle login called", result)
      if (!result.success) {
        Swal.fire({
          icon: "warning",
          title: "Login Failed",
          text: result.message,
          timer: 3000,
          showConfirmButton: false
        });
        return;
      }
      let user = result.data[0];
      console.log("user", user)
      if (user.userType === "normal") {
        const { token, id, role_id, userType } = user;
        console.log("normal side flowing")
        // Store user details in localStorage
        localStorage.setItem("access_token", token);
        localStorage.setItem("user_id", id);
        localStorage.setItem("role_id", role_id);
        localStorage.setItem("userType", userType);
        setRole(role_id);
        setIsAuthenticated(true);
        setUserType("normal");

        let data = {
          "userId": id,
          "entryTime": currentDate,
          "include24HoursAttendance": true,
          "status": 0
        }

        let isPresentCheck = await Apiservice.GetAttendance(data);
        console.log("isPresentCheck", isPresentCheck)
        if (isPresentCheck.success === true) {
          localStorage.setItem('siteId', isPresentCheck.data[0].site_id)
        }

        // Redirect based on role
        window.location.replace(
          role_id === 1 || role_id === '1'
            ? "/dashboard"
            : "/overviewofcourse"
        );



      }
      else {
        localStorage.setItem("userType", "floater");

        // ❌ DO NOT set authenticated true
        setIsAuthenticated(true);
        setUserType("floater");

        window.location.replace("/floaterattendance");
      }



    } catch (error) {
      console.error("Login failed:", error);
      alert("Something went wrong. Please try again later.");
    }
  };

  const handleLogout = () => {
    console.log("logout called on app.js")
    localStorage.clear();
    setIsAuthenticated(false);
    window.location.replace("/login");
  };

  const toggleSideBar = () => {
    setShowSideBar(!showSideBar);
  };

  return (
    <Router>
      {isAuthenticated ? (
        <div className="container-fluid mainappbackgroundcolour" style={{ minHeight: "100vh" }}>
          <div className="row">
            <Header onLogout={handleLogout} toggleSidebar={toggleSideBar} showSideBar={showSideBar} />
          </div>
          <div className="row" style={{ minHeight: "calc(100vh - 60px)" }}>
            {showSideBar && (
              <div
                className="col-md-3 col-12 d-md-block"
                style={{ overflowY: "auto", height: "calc(100vh - 60px)" }}
              >
                <Sidemenubar />
              </div>
            )}

            <div
              className={`${showSideBar ? "col-md-9" : "col-md-12"
                } col-12`}
              style={{
                overflowY: showSideBar ? "auto" : undefined,
                height: showSideBar ? "calc(100vh - 60px)" : undefined
              }}
            >
              {/* <div className="content-container" style={{ padding: "15px" }}> */}
              <div className="content-container p-0 pagebackgroundcolour">
                <Routes>
                  <Route path="/header" element={<Header />} />
                  <Route path="/footer" element={<Footer />} />
                  <Route path="/allstaff" element={<AllStaff />} />
                  <Route path="/staffprofile/:user_id" element={<StaffProfile />} />
                  <Route path="/staffadd" element={<StaffAdd />} />
                  <Route path="/staffedit/:user_id" element={<StaffEdit />} />
                  <Route path="/teststaffadd" element={<TestStaffAdd />} />
                  <Route path="/addquestion/:examId" element={<AddQuestion />} />
                  <Route path="/allquestions/:examId" element={<AllQuestions />} />
                  <Route path="/questionedit/:questionId" element={<QuestionEdit />} />
                  <Route path="/overviewofcourse" element={<OverviewOfCourse />} />
                  <Route path="/quiz/:examId" element={<Quiz />} />
                  <Route path="/quizadd" element={<QuizAdd />} />
                  <Route path="/quizedit" element={<QuizEdit />} />
                  <Route path="/quiztest/:examId" element={<QuizTest />} />
                  <Route path="/quizsummary" element={<QuizSummary />} />
                  <Route path="/quizreview/:summary_id" element={<QuizTestReview />} />
                  <Route path="/quizlist" element={<QuizList />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/lmsreport" element={<LMSReport />} />
                  <Route path="/attendancereport" element={<AttendanceReport />} />
                  <Route path="/consolidate" element={<ConsolidateReport />} />
                  <Route path="/timesheet" element={<TimeSheet />} />
                  <Route path="/home" element={<Home />} />
                  <Route path='/attendance' element={<Attendance />} />
                  <Route path="/floaterstaffDetails" element={<FloaterStaffDetails />} />
                  <Route path="/floaterattendance" element={<FloaterAttendance />} />
                  <Route path="/floatercredits" element={<FloaterPage />} />
                  <Route path="/sites" element={<AllSites />} />
                  <Route path='/addsite' element={<AddSite />} />
                  <Route path="/siteedit" element={<SiteEdit />} />
                  <Route path="/sitedetails/:siteId" element={<SiteProfile />} />
                  <Route path='/staffattendance' element={<StaffAttendance />} />
                  <Route path="/staffattendanceedit" element={<StaffAttendanceEdit />} />
                  <Route path="/ket" element={<KETAdd />} />
                  <Route path="/ketedit" element={<KETEdit />} />
                  <Route path="/leaveform" element={<LeaveForm />} />
                  <Route path="/leaveapplicationlist" element={<LeaveApplicationList />} />
                  <Route path="/pwmprogression" element={<PWMProgression />} />
                  <Route path="/salariedstaff" element={<SalariedStaffs />} />
                  <Route path="/payslip" element={<Payslip />} />
                  <Route path="/paysliplist" element={<PaylipList />} />
                  <Route path="/sop" element={<SOP />} />
                  <Route path="/sopadd" element={<SOPAdd />} />
                  <Route path="/incidentreport" element={<IncidentReport />} />
                  <Route path="/incidentreportadd" element={<IncidentReportAdd />} />
                  <Route path="/incidentreportview" element={<IncidentReportView />} />
                  <Route path="/eoccurrence" element={<EOccurrence />} />
                  <Route path="/eoccurrenceadd" element={<EOccurrenceAdd />} />
                  <Route path="/eoccurrencereport" element={<EoccurrenceReport />} />
                  <Route
                    path="*"
                    element={
                      role === "Super Admin" || role === "Admin" || role === 1 || role === '1' ? (
                        <Navigate to="/home" />
                      ) : (
                        <Navigate to="/home" />
                      )
                    }
                  />
                </Routes>
              </div>
            </div>
          </div>
          <div className="row">
            <Footer />
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;
